import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { akEditorFloatingDialogZIndex, akEditorSwoopCubicBezier } from '@atlaskit/editor-shared-styles';
import { fg } from '@atlaskit/platform-feature-flags';
import { MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT } from './MainToolbar';

// Base styles that don't depend on feature flags
var baseToolbarStyles = css({
  position: 'relative',
  alignItems: 'center',
  boxShadow: 'none',
  borderBottom: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #091E4224)"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
  transition: "box-shadow 200ms ".concat(akEditorSwoopCubicBezier),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
  zIndex: akEditorFloatingDialogZIndex,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
  display: 'flex',
  height: 'var(--ak-editor-fullpage-toolbar-height)',
  flexShrink: 0,
  backgroundColor: "var(--ds-surface, #FFFFFF)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '& object': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    height: '0 !important'
  }
});
var flexibleIconSize = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '& span svg': {
    maxWidth: '100%'
  }
});
// box-shadow is overriden by the mainToolbar
var mainToolbarWithKeyline = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
});
var mainToolbarTwoLineStyle = css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
  flexWrap: 'wrap',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: "calc(var(--ak-editor-fullpage-toolbar-height) * 2)"
}));
export var MainToolbarWrapper = function MainToolbarWrapper(_ref) {
  var showKeyline = _ref.showKeyline,
    twoLineEditorToolbar = _ref.twoLineEditorToolbar,
    children = _ref.children,
    testId = _ref['data-testid'];
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    css: [baseToolbarStyles, fg('platform-visual-refresh-icons') && flexibleIconSize, showKeyline && mainToolbarWithKeyline, twoLineEditorToolbar && mainToolbarTwoLineStyle],
    "data-testid": testId
  }, children);
};